// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__R+PmN","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__v7hiZ"};